'use strict';

module.exports = Object.freeze({
    BUSY_STATE_CHANGED: 'busy_state_changed',
    NO_DATA_CHANGED: 'no_data_changed',
    ERROR: 'error'
});



//////////////////
// WEBPACK FOOTER
// ./src/widget/scripts/lib/commons/events/defs/events.js
// module id = 8
// module chunks = 0 1